import type { WmsShipmentInboundType } from 'schemas/shipment/inbound/detail';
import { InboundShipmentContentsTab } from './InboundShipmentContentsTab';
import { InboundShipmentIntakeTab } from './InboundShipmentIntakeTab';
import { InboundDetailMainTabs, MainDetailPanel } from './inboundDetailStyled';

type InboundShipmentMainPanelProps = {
  data: WmsShipmentInboundType;
  stepIndex: number;
  activeTabKey: string;
  onTabChange: (key: string) => void;
  onMarkArrived?: () => void;
  markingArrived?: boolean;
  onMarkCompleted?: () => void;
  markingCompleted?: boolean;
};

export function InboundShipmentMainPanel({
  data,
  stepIndex,
  activeTabKey,
  onTabChange,
  onMarkArrived,
  markingArrived,
  onMarkCompleted,
  markingCompleted,
}: InboundShipmentMainPanelProps) {
  return (
    <MainDetailPanel>
      <InboundDetailMainTabs
        tabPosition="left"
        activeKey={activeTabKey}
        onChange={onTabChange}
        items={[
          {
            key: 'intake',
            label: 'Intake',
            children: (
              <InboundShipmentIntakeTab
                data={data}
                stepIndex={stepIndex}
                onMarkArrived={onMarkArrived}
                markingArrived={markingArrived}
                onMarkCompleted={onMarkCompleted}
                markingCompleted={markingCompleted}
              />
            ),
          },
          {
            key: 'contents',
            label: 'Contents',
            children: <InboundShipmentContentsTab data={data} />,
          },
        ]}
      />
    </MainDetailPanel>
  );
}
